module.exports = __webpack_public_path__ + "static/media/profilephone.3a68d618.svg";